import { JobEntity, JobOperation } from '@commenda/api';
import { LoadingIndicator } from '@commenda/kakashi';

import { IndirectTaxJobHelper } from '../helpers/IndirectTaxJobHelper';
import { useIndirectTaxJobWatcher } from '../hooks/useIndirectTaxJobWatcher';
import { useIndirectTaxCSVJobWatcher } from '../hooks';

interface IndirectTaxDataSyncBannerProps {
  corporationId: number;
  entity: JobEntity;
  isSyncInProgress?: boolean;
}

const IndirectTaxDataSyncBanner = ({
  corporationId,
  entity,
  isSyncInProgress = false,
}: IndirectTaxDataSyncBannerProps) => {
  const { isJobInProgressForOperation } = useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity,
  });

  const {
    isCSVProcessingInProgress,
  } = useIndirectTaxCSVJobWatcher({ corporationId });

  const isImportInProgress = isJobInProgressForOperation(entity, JobOperation.IMPORT);
  const isDeleteInProgress = isJobInProgressForOperation(entity, JobOperation.DELETE);
  const isExportInProgress = isJobInProgressForOperation(entity, JobOperation.EXPORT);
  const isTransactionCSVProcessingInProgress = isCSVProcessingInProgress() && (entity === JobEntity.INVOICE);

  const isAnyJobInProgress =
    isSyncInProgress || isImportInProgress || isDeleteInProgress || isExportInProgress || isTransactionCSVProcessingInProgress;

  if (!isAnyJobInProgress) return null;

  const entityName = IndirectTaxJobHelper.ENTITY_NAME_MAP[entity] ?? 'Data';

  const message =
    isSyncInProgress || isImportInProgress || isTransactionCSVProcessingInProgress
      ? `${entityName} sync in progress`
      : isDeleteInProgress
        ? `${entityName} delete in progress`
        : `${entityName} export in progress`;

  return (
    <div className="h-12 flex items-center p-lg gap-md rounded-md bg-bg-tertiary mt-3xl mx-3xl">
      <LoadingIndicator size={20} />
      <p className="txt-small-regular text-text-primary">{message}</p>
    </div>
  );
};

export { IndirectTaxDataSyncBanner };
